import { Component, OnInit, EventEmitter, Input, Output, ElementRef, NgZone, ViewChild } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';


@Component({
  selector: 'app-new-activity-manually',
  templateUrl: './new-activity-manually.component.html',
  styleUrls: ['./new-activity-manually.component.css']
})
export class NewActivityManuallyComponent implements OnInit {
  @Input() open: Boolean;
  @Output() close = new EventEmitter<boolean>();
  @Output() mainClose = new EventEmitter<boolean>();
  @Input() activityData: any;
  @Input() postoutcomes: any;

  @ViewChild("search")
  @ViewChild('template1') template1: any;
  public searchElementRef: ElementRef;
  modalRef: BsModalRef;
  minDate = new Date();
  logged;
  start;
  latitude: number;
  longitude: number;
  searchControl: FormControl;
  zoom: number;
  pic: any = null;
  submitted:  boolean = false;
  constructor(
    public translations: TranslationService,
    private apiservice: ApiService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {


    this.zoom = 4;
    this.latitude = 39.8282;
    this.longitude = -98.5795;

    this.searchControl = new FormControl();

    // this.setCurrentPosition();
  }

  ngOnChanges(changes) {
    console.log(this.activityData);
    for (let propName in changes) {
      let chng = changes[propName];
      let cur = chng.currentValue;
      if (propName == 'open' && cur == true) {
        if (this.activityData && this.activityData.startTime) {
          if (this.postoutcomes.length > 0) {
            this.modalRef = this.modalService.show(this.template1);
          }
        }
        break;
      }
    }
  }

  // setCurrentPosition() {
  //   if ("geolocation" in navigator) {
  //     navigator.geolocation.getCurrentPosition((position) => {
  //       this.latitude = position.coords.latitude;
  //       this.longitude = position.coords.longitude;
  //       this.zoom = 12;
  //     });
  //   }
  // }

  endTimeSelected(e) {
    console.log('i am here')
    if (this.postoutcomes.length > 0) {
      this.modalRef = this.modalService.show(this.template1);
    }
  }

  postOutcomeChange(e, outcome) {
    let postoutcome = this.activityData.postoutcomes;
    if (e.target.checked) {
      postoutcome.push(outcome._id);
      this.activityData['postoutcomes'] = postoutcome;
      return
    }
    let index = postoutcome.findIndex(el => el == outcome._id);
    postoutcome.splice(index, 1);
    this.activityData['postoutcomes'] = postoutcome;
    return
  }
  postOutcomeValue(e){
    this.activityData['postoutcomeValue'] = e.target.value;
    return;
  }

  placeMarker($event) {
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.zoom = 4;
  }

  timeLogged() {
    if (this.start && this.activityData.endTime) {
      var a = moment(this.start);
      var b = moment(this.activityData.endTime);
      return moment.utc(b.diff(a, 'seconds') * 1000).format('HH:mm');
    } else {
      return '0h 0min'
    }
  }

  fileSelected(event) {
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      this.pic = file;
    }
  }


  submit() {
    let final = JSON.parse(JSON.stringify(this.activityData));
    final['location'] = JSON.stringify({ long: this.longitude, lat: this.latitude });
    if (this.start && this.activityData.endTime) {
      final['startTime'] = this.start;
      var a = moment(this.start);
      var b = moment(this.activityData.endTime);
      final['timeLogged'] = b.diff(a, 'seconds');
    }
    let formData = new FormData();
    Object.keys(final).forEach(function (key) {
      if (key == 'postoutcomes' || key == 'preoutcomes') {
        formData.append(key, JSON.stringify(final[key]));
      } else {
        formData.append(key, final[key]);
      }
    });
    if (this.pic) {
      formData.append('pic', this.pic);
    }
    this.apiservice.createLogs(formData).subscribe(() => {
      this.pic = null;
      this.submitted = true;
      this.mainClose.emit();
      this.close.emit();
      window.location.reload(true);
    })
  }

}
